module.exports = "/static/853f03b911e7458838b53652c65037f0.svg";